import cds from "./cds";
import dea from "./dea";

export default {
  cds,
  dea
}
